// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-widget[data-v-49e83a87]{margin-top:27px}.user-widget[data-v-49e83a87],.user-widget a[data-v-49e83a87]{color:#747474}.user-widget>button[data-v-49e83a87]{display:inline-block;background:#fff!important;border:.5px solid hsla(0,0%,59.2%,.74);box-sizing:border-box;border-radius:6px;padding:8px 24px;white-space:nowrap;height:35px!important}.user-widget>div>img[data-v-49e83a87]{margin-top:1px;vertical-align:top}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
